import * as ApiRequests from '../../api/requests';
import { AuthHelper } from '../../types/auth-helper-types';
// import { Data, getDataFromApiResponse } from '../../types/data-providers';
// import { DevicePropertiesDetails, DeviceChannelData } from '../../types/device';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getOrganizationType = async (authHelper: AuthHelper, organizationId: string) => {
    const getOrgTypeDetailsResult = await ApiRequests.getOrganizationType(
        {
            organizationId: organizationId,
        },
        { authHelper }
    );

    if (!getOrgTypeDetailsResult.ok) {
        console.error(ApiRequests.extractResponseNotOkMessage(getOrgTypeDetailsResult.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(getOrgTypeDetailsResult.response));
    }
    return getOrgTypeDetailsResult.response.data;
};

export { getOrganizationType };
